import { sanitize } from 'dompurify';
import { twMerge } from 'tailwind-merge';

type Props = {
  html: string;
  className?: string;
};

const ALLOWED_TAGS = ['p', 'ul', 'ol', 'li', 'u', 'b', 'br'];

export function CustomHtml({ html, className }: Props) {
  return (
    <div
      className={twMerge('custom-html', className)}
      dangerouslySetInnerHTML={{
        __html: sanitize(html, {
          USE_PROFILES: { html: true },
          ALLOWED_TAGS,
          ALLOWED_ATTR: [],
        }),
      }}
    ></div>
  );
}
